import { DotLegalDialog, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { PaymentTermViewModel } from "../paymentTerms/PaymentTerms.types.ts";
import { useAddEditPaymentTermDialogHooks } from "./AddEditPaymentTermDialog.hooks.ts";

export interface IAddEditPaymentTermDialogProps {
    onDialogClose: () => void;
    isAdd: boolean;
    selectedPaymentTerm: PaymentTermViewModel | undefined;
    onSaved: () => void;
}

function AddEditPaymentTermDialog(props: IAddEditPaymentTermDialogProps) {
    const { translateString } = useTranslation();
    const { isSaving, onModelChange, onSave, saveModel, validation } = useAddEditPaymentTermDialogHooks(props);

    return (
        <DotLegalDialog
            size="sm"
            inProgress={isSaving}
            header={props.isAdd ? translateString("createPaymentTerm") : translateString("editPaymentTerm")}
            buttonOkText={props.isAdd ? translateString("create") : translateString("save")}
            open
            onDialogClose={props.onDialogClose}
            onOkClick={onSave}
        >
            <DotLegalTextField
                label={translateString("name")}
                value={saveModel.name}
                debounce={false}
                errorText={validation.getErrorsForDisplay("name")}
                onChange={(name) => onModelChange((model) => (model.name = name))}
            />
        </DotLegalDialog>
    );
}

export default AddEditPaymentTermDialog;
